import CoachingView from 'coaching/components/CoachingView';
import React, { useEffect } from 'react';
import { InjectedRouter } from 'react-router';
import { Location } from 'history';
import DeprecatedCoachingAvailabilityView, {
  Props as DeprecatedAvailabilityProps,
} from 'coaching/components/DeprecatedCoachingAvailabilityView/CoachingAvailabilityView';
import CoachAvailabilityContainer from 'coaching/containers/CoachAvailabilityContainer';
import CoachingScheduleView from 'coaching/components/CoachingScheduleView/CoachingScheduleView';
import IsRemindCoachContainer from 'coaching/containers/IsRemindCoachContainer';
import DeprecatedCoachingAvailabilityContainer from 'coaching/DeprecatedCoachingAvailabilityContainer';
import CurrentUser from 'auth/CurrentUser';
import CoachingHomeTabView, { Tab } from 'coaching/components/CoachingHomeView/CoachingHomeTabView';
import CoachingConstants from 'coaching/CoachingConstants';

import EventTracking from 'lib/EventTracking';

type Props = {
  router: InjectedRouter;
  location: Location;
};

export const coachDashboardPrefix = 'coaching.coach_dashboard';

export default function CoachDashboard(props: Props) {
  const { router, location } = props;
  const user = CurrentUser.isSignedIn() && CurrentUser.getUser();
  if (!user) {
    return null;
  }

  const hasFutureAvailabilityFeatureFlag = user.hasFeature('future_coach_availability.web.aug-20');

  useEffect(() => {
    EventTracking.trackKey(`${coachDashboardPrefix}.view`);
  }, []);

  const tabs: Tab[] = [
    {
      title: 'Sessions',
      element: (
        <CoachingView isCoach headerType="none">
          <CoachingScheduleView />
        </CoachingView>
      ),
      route: CoachingConstants.COACHING_SCHEDULE_ROUTE,
      clickEventKey: `${coachDashboardPrefix}.coach_dashboard_schedule.click`,
      viewEventKey: `${coachDashboardPrefix}.coach_dashboard_schedule.view`,
    },
    {
      title: 'Availability',
      element: hasFutureAvailabilityFeatureFlag ? (
        <CoachingView isCoach headerType="none">
          <CoachAvailabilityContainer />
        </CoachingView>
      ) : (
        <DeprecatedCoachingAvailabilityContainer user={user}>
          {(availabilityProps: DeprecatedAvailabilityProps) => (
            <CoachingView isCoach headerType="none">
              <DeprecatedCoachingAvailabilityView {...availabilityProps} />
            </CoachingView>
          )}
        </DeprecatedCoachingAvailabilityContainer>
      ),
      route: CoachingConstants.COACHING_AVAILABILITY_ROUTE,
      clickEventKey: `${coachDashboardPrefix}.coach_dashboard_availability.click`,
      viewEventKey: `${coachDashboardPrefix}.coach_dashboard_availability.view`,
    },
  ];

  return (
    <IsRemindCoachContainer userUuid={user.getUuid()}>
      <CoachingHomeTabView
        title="Coach dashboard"
        tabs={tabs}
        renderAllTabs={true}
        location={location}
        router={router}
        // isCoach is always true since this is a coach-only view
        isCoach
      />
    </IsRemindCoachContainer>
  );
}
